// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OkNt","title":"styles_title__1L5O5"};